import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ConversationAgentEntity } from './conversation-agent.entity';
import { RbacRoleEntity } from './rbac-role.entity';

@Entity('_conversation_agent_role_default')
@Index('uk_role_active', ['fkRbacRoleId', 'deletedDate'], { unique: true })
@Index('idx_agent', ['conversationAgentId'])
@Index('idx_role', ['fkRbacRoleId'])
export class ConversationAgentRoleDefaultEntity extends BaseEntity {
	@Column({
		name: '_fk_conversation_agent__id',
		type: 'int',
		unsigned: true,
		nullable: false,
	})
	public conversationAgentId!: number;

	@Column({
		name: '_fk_rbac_role__id',
		type: 'int',
		unsigned: true,
		nullable: false,
	})
	public fkRbacRoleId!: number;

	@ManyToOne(
		() => ConversationAgentEntity,
		(agent) => agent.roleDefaults,
		{ onDelete: 'CASCADE' },
	)
	@JoinColumn({ name: '_fk_conversation_agent__id' })
	public agent?: ConversationAgentEntity;

	@ManyToOne(() => RbacRoleEntity, { onDelete: 'CASCADE' })
	@JoinColumn({ name: '_fk_rbac_role__id' })
	public role?: RbacRoleEntity;
}
